<div class="preview-layout__banner" *ngIf="previewSessionService.active$ | async">
  <div class="preview-layout__banner-content">
    <div class="preview-layout__banner-user">{{getViewedUserEmail}}</div>
    <div class="preview-layout__banner-info">
      <nb-icon class="preview-layout__banner-icon" icon="eye-outline"></nb-icon>

      <span class="preview-layout__banner-title"> Preview mode </span>

      <span class="preview-layout__banner-description">
        You are viewing a preview of this application.
      </span>
      <span class="preview-layout__banner-time">
        Time remaining:
        <strong>{{ remainingTime$ | async }}</strong>
      </span>
    </div>

    <div class="preview-layout__banner-actions">
      <button nbButton size="tiny" status="control" class="preview-layout__banner-button" (click)="stopPreview()">
        Exit preview
        <nb-icon icon="external-link-outline"></nb-icon>
      </button>
    </div>
  </div>
</div>